export enum ErrorCodes {
  BAD_METHOD_CALL = 400,
  UNAUTHORIZED = 401,
}
